import { AccessDeniedPage } from 'pages/AccessDeniedPage';

import { Route, Routes } from 'react-router-dom';

import { ReplaceWorkOrder } from '../../ReplaceWorkOrder';
import { UerWorkOrderActsKc2List } from '../UerWorkOrderActsKc2List';
import { WorkOrder } from '../WorkOrder';
import { WorkOrderNew } from '../WorkOrderNew';
import { UerWorkOrderStructure } from '../WorkOrderStructure/UerWorkOrderStructure';
import { WorkOrderUploadModal } from '../WorkOrderUpload';

export const WorkOrderRoutes = () => (
    <Routes>
        <Route path="/:orderId/*" element={<WorkOrderNew />} />
        <Route path="/:orderId/old/*" element={<WorkOrder />} />
        <Route path=":orderId/structure" element={<UerWorkOrderStructure />} />
        <Route path="/:orderId/actsKC2List" element={<UerWorkOrderActsKc2List />} />
        <Route path="/:orderId/actsKC2List/:groupType" element={<UerWorkOrderActsKc2List />} />
        <Route path="/:orderId/actsKC2List/:groupType/:subGroup" element={<UerWorkOrderActsKc2List />} />
        <Route path="/upload" element={<WorkOrderUploadModal />} />
        <Route path="/:orderChangeId/replace" element={<ReplaceWorkOrder />} />
        <Route path="*" element={<AccessDeniedPage />} />
    </Routes>
);

WorkOrderRoutes.displayName = 'WorkOrderRoutes';
